import createElement from './createElement';
import { TrackedInfo } from '../global-constants';

const setFormSessionId = (form) => {
	if (form) {
		// const enableLogs =
		// 	new URLSearchParams(window.location.search).get('_mode') ===
		// 	'debug';
		// Get session Id out of session Storage
		const sessionId = sessionStorage.getItem(TrackedInfo.USER_SESSION_ID);

		if (sessionId) {
			const sessionReferer = sessionStorage.getItem(
				TrackedInfo.SESSION_REFERRER
			);
			const userSessionIdFormField = form.querySelector(
				'input[name="userSessionId"]'
			);

			if (userSessionIdFormField) {
				userSessionIdFormField.setAttribute('value', sessionId);
			} else {
				form.appendChild(
					createElement(
						`<input type='hidden' name='userSessionId' class='hidden' data-id value=${sessionId}>`
					)
				);
			}

			if (sessionReferer) {
				form.appendChild(
					createElement(
						`<input type='hidden' name='userSessionReferrer' class='hidden' data-id value=${sessionReferer}>`
					)
				);
			}
		}
	}
};

export default setFormSessionId;
